export default __webpack_public_path__ + "static/media/frame798.244f695e.svg";